import { render, staticRenderFns } from "./moneyWater.vue?vue&type=template&id=4ac6f53a&scoped=true"
import script from "./moneyWater.vue?vue&type=script&lang=js"
export * from "./moneyWater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6f53a",
  null
  
)

export default component.exports